<template>
    <div>
        <div class="orderSearchBox">
            <div class="timeSearch">
                <span style="color: #b2b2b2;">区间筛选</span>
                <el-date-picker
                    v-model="createDateValue"
                    @change="chooseDate"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="—"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </div>
            <el-input v-model="orderNo" placeholder="订单编号"></el-input>
            <el-button class="searchBtn" @click="searchUnProcessInfo">搜索</el-button>
            <el-button type="text" class="resetBtn" @click="clearUnProcessSearch">
                <i class="iconfont icon-qingchushujuku"></i>
                <span>清除条件</span>
            </el-button>
        </div>
        <el-table
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%" class="tableContent">
            <el-table-column
                prop="orderId"
                label="订单编号"
                header-align="center"
                show-overflow-tooltip
                align="center">
            </el-table-column>
            <el-table-column
                prop="orderAmount"
                label="销售金额"
                header-align="center"
                show-overflow-tooltip
                align="center">
            </el-table-column>
            <el-table-column
                label="操作"
                header-align="center"
                align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="toDetail(scope.row)">订单详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            v-if="tableData.length != 0"
            background
            @current-change="handleCurrentChange"
            @prev-click="handleCurrentChange"
            @next-click="handleCurrentChange"
            layout="total,prev, pager, next,jumper"
            :current-page="current"
            :page-size="pageSize"
            :total="total" class="pagination">
        </el-pagination>

    </div>
</template>

<script>
import {getNoneSplitStatusList} from '../../utils/interface';

export default {
    name: "unProcess",
    data() {
        return {
            orderNo: '',
            createDateValue: null,
            activeName: '0',
            tableData: [],
            current: 1,
            pageSize: 10,
            total: 0,
            loading:false,
            startTime:"",
            endTime:"",
        }
    },
    created(){
        this.getUnProcessBalanceList();
    },
    methods: {
        searchUnProcessInfo(){
            this.current = 1;
            this.getUnProcessBalanceList();
        },
        clearUnProcessSearch(){
            this.orderNo = ''
            this.createDateValue = null;
            this.startTime = "";
            this.endTime = "";
            this.searchUnProcessInfo();
        },
        // 时间格式
        chooseDate(){
            this.startTime = "";
            this.endTime = "";
            // 判断时间
            if(this.createDateValue!=null && this.createDateValue.length==2){
                this.startTime = this.timeDate(this.createDateValue[0]);
                this.endTime = this.timeDate(this.createDateValue[1]);
            }
        },
        timeDate(value){
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        },
        getUnProcessBalanceList(){
            this.loading = true;
            let params = {
                type:'PLATFORM_ADVANCES',
                orderNo:this.orderNo,
                startDate:this.startTime,
                endDate:this.endTime,
                current:this.current,
                pageSize:this.pageSize,
            };
            getNoneSplitStatusList(params).then((res)=>{
                this.total = res.total;
                this.tableData = res.list;
                this.loading = false
            });
        },
        // 分页
        handleCurrentChange(val) {
            this.current = val;
            this.getUnProcessBalanceList();
        },
        // 跳转至详情页
        toDetail(item){
            const orderType = item.orderBaseType;
            if(orderType === 'PRINT') {
                this.$router.push({name:'printOrderDetails',params:{uuid:item.orderUuid}});
            }
            else if(orderType === 'SERVICE') {
                this.$router.push({name:'serverOrderDetails',params:{uuid:item.orderUuid}});
            }
            else if(orderType === 'SHOP') {
                this.$router.push({name: 'mallOrderDetails', params: {orderBaseUuid: item.orderBaseUuid}});
            }
            else if(orderType === 'DESIGN') {
                this.$router.push({name:'designOrderDetail',params:{uuid:item.orderUuid}});
            }
            else if(orderType === 'MODEL') {
                this.$router.push({
                    path: '/modelOrderDetail',
                    query: {
                        uuid: item.orderUuid
                    }
                })
            }
        },
    }
}
</script>

<style scoped lang="less">
.printOrderListBox {
    padding: 24px 20px 20px;
    .orderListTabs{
        // position: absolute;
        // left: 0;
        // top: 0;
        z-index: 999;
        background: #fff;
        width: 100%;
        padding: 20px;
    }
    /deep/ .el-tabs__item {
        padding: 0 25px !important;
        text-align: center;

        &:hover {
            color: #3686d7
        }

        &:after {
            content: "";
            position: absolute;
            right: 0;
            bottom: 12px;
            width: 1px;
            height: 15px;
            background-color: #E4E7ED;
            z-index: 1;
        }

        &:last-child:after {
            content: "";
            width: 0;
            height: 0;
        }
    }
    /deep/ .el-tabs__active-bar {
        height: 3px;
        background-color: #3686d7;
    }
    /deep/ .el-tabs__item.is-active {
        color: #3686d7
    }
    /deep/ .el-tabs__nav-wrap::after {
        height: 1px;
    }
    .orderSearchBox {
        .timeSearch{
            background-color:#f2f4f7;
            height: 35px;
            display: flex;
            align-items: center;
            margin-bottom: 22px;
            margin-right: 30px;
            border-radius: 8px;
            span{
                font-size: 12px;
                color: #c0c4cc!important;
                font-weight: normal;
                padding-left: 15px;
                margin-right: 5px;
            }
            // /deep/ .el-range-input{
            //         background-color: #f2f4f7;
            //             &:hover, &:focus {
            //             background-color: #fff;
            //             // border: 1px solid #108EE9;
            //         }
            // }
            /deep/input::-webkit-input-placeholder {
                color: #c0c4cc;
                font-size: 12px;
            }
            /deep/.el-range-input:hover{
                background-color: #fff!important;
            }
            /deep/ .el-date-editor .el-range-separator{
                line-height: 25px;
                color: #c0c4cc;
            }
            /deep/ .el-date-editor .el-range__close-icon{
                line-height: 28px;
            }
            /deep/ .el-input__inner:hover  .el-range-input, /deep/ .el-input__inner:focus  .el-range-input{
                background-color: white;
            }
            /deep/ .el-input__inner {
                width: 225px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;
                .el-range-input{
                    background-color:#f2f4f7 ;
                }
                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;
                }
            }
            /deep/ .el-icon-date:before {
                content: "\E78E";
                display: none;
            }
            /deep/.el-input__icon{
                // display: none;
            }
        }
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        /deep/ .el-input {
            width: initial;
            margin-bottom: 22px;
            margin-right: 30px;
        }
        /deep/.el-input__suffix-inner .el-icon-circle-close{
            line-height: 32px;
        }
        /deep/ .el-input__inner {
            width: 242px;
            height: 35px;
            min-height: 35px;
            font-size: 12px;
            color: #999999;
            background-color: #f2f4f7;
            border: 1px solid #f2f4f7;
            border-radius: 5px;

            &:hover, &:focus {
                background-color: #fff;
                border: 1px solid #108EE9;
            }
        }

        /deep/ .el-input__prefix {
            top: -3px;
        }

        /deep/ .el-input__suffix {
            top: 2px;
        }

        /deep/ .el-button {
            display: block;
            line-height: 35px;
            padding: 0;
            height: 35px;
        }

        .searchBtn {
            width: 82px;
            background: #3d7fff;
            border: none;
            border-radius: 15px;
            font-size: 14px;
            color: #FFFFFF;
            margin-bottom:22px;
        }

        .resetBtn {
            color: #333333;
            margin-bottom:22px;
        }
    }
    .orderListTable {
        .tableTool {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;

            .toolLeft {
                font-size: 12px;
                color: rgba(0, 0, 0, 0.847);

                .num {
                    color: #356FDF;
                }

                button {
                    padding: 0;
                    margin-left: 15px;
                    width: 80px;
                    height: 30px;
                    background: rgba(242, 244, 247, 1);
                    box-sizing: border-box;
                    border: 1px solid rgba(21, 126, 251, 1);
                    border-radius: 5px;
                    font-size: 12px;
                    color: #157EFB;
                    line-height: 30px;
                    text-align: center;

                    &:hover {
                        background: #157EFB;
                        box-sizing: border-box;
                        border: 1px solid #157EFB;
                        color: #fff;
                    }
                }
            }

            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .tableHeader {
            display: flex;
            width: 100%;
            height: 35px;
            line-height: 35px;
            background: #f3f7ff;
            border-radius: 5px;
            margin: 0 0 15px;

            li {
                text-align: center;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.85);
                padding-right: 67px;
            }
        }
        .orderNomesaage {
            color: #888;
            text-align: center;
            padding: 15px 0;
        }
        .select{
            padding: 0 20px;
        }
        .tableBody {
            li {
                // width: 100%;
                border: 1px solid #f2f2f2;
                border-radius: 10px;

                .itemTop {
                    // width: 100%;
                    height: 42px;
                    background: #ebf3fb;
                    line-height: 42px;
                    font-size: 14px;
                    color: #333;
                    padding: 0 20px;
                    display: flex;
                    align-items: center;
                    position: relative;

                    div {
                        margin-right: 30px;
                    }

                    .merchantInfo {
                        display: flex;
                        align-items: center;

                        i {
                            color: #3d7fff;
                            font-size: 25px;
                            cursor: pointer;
                            padding-left: 5px;
                            display: block;
                        }

                        img {
                            display: block;
                            padding-right: 5px;
                        }
                    }

                    .complainBtn {
                        color: #999;
                        position: absolute;
                        right: 20px;
                    }
                }

                .itemBottom {
                    display: flex;
                    align-items: center;
                    color: #333;
                    font-size: 13px;

                    .orderInfo {
                        padding: 20px;
                        display: flex;
                        position: relative;
                        img {
                            display: block;
                            width: 100px;
                            height: 100px;
                            border-radius: 10px;
                            margin-right: 30px;
                        }
                        .imgThree {
                            width: 100px;
                            height: 100px;
                            border-radius: 10px;
                            margin-right: 30px;
                        }

                        .infoContent {
                            .infoName {
                                font-size: 14px;
                                color: #000000;
                                padding-bottom: 10px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                max-width: 300px;
                            }

                            .infoOther {
                                font-size: 13px;
                                color: #999999;
                                padding-bottom: 8px;
                            }
                        }
                    }



                    .arguments {
                        padding: 20px;
                    }

                    .argumentsName {
                        padding-bottom: 8px;
                    }
                    .payment {
                        h3 {
                            font-size: 14px;
                            font-weight: 700;
                            margin: 0;
                        }

                        .title {
                            font-size: 12px;
                            color: #999999;
                        }
                    }
                    .status{
                        font-size: 14px;
                    }
                    .operationBtn{
                        display: block;
                        color: #0C75D3;
                        text-align: center;
                        width: 100%;
                        margin: 0;
                    }
                }
            }
        }

        .name {
            flex: 1;
            position: relative;
            display: flex;
            justify-content: center;
        }

        .price {
            width: 120px;
            text-align: center;
        }

        .num {
            width: 95px;
            text-align: center;
        }

        .arguments {
            width: 294px;
            display: flex;
            justify-content: center;
        }

        .payment {
            width: 162px;
            text-align: center;
        }

        .status {
            width: 124px;
            text-align: center;
        }

        .operation {
            width: 145px;
            text-align: center;
            .operationUploadBtn{
                width: 102px !important;
                height: 34px;
                padding: 0;
                line-height: 34px;
                text-align: center;
                font-weight: 700;
                color: rgba(0, 102, 204, 0.8);
                font-size: 14px;
                border-color: rgba(0, 102, 204, 0.8);
                display: block;
                margin: 0 auto 10px !important;
            }
        }
    }
    .preview{
        position: absolute;
        width: 85px;
        height: 25px;
        padding: 0;
        text-align: center;
        border: none;
        left: 28px;
        bottom: 33px;
        background: rgba(255,255,255,.6);
        font-size: 12px;
        color: #1296DB;
        font-weight: 700;
    }
    .submitButtonGroup{
        /deep/.el-form-item__content{
            text-align: center;
            margin-left: 0 !important;
            button{
                padding: 0;
                width: 120px;
                height: 35px;
                line-height: 35px;
                text-align: center;
            }
        }
    }
    .pagination {
        margin-top: 20px;
        text-align: right;
    }
}

.printNumber {
    display: flex;
    margin-bottom: 30px;
    .printNumber_box {
       background: #efefef;
       padding: 20px;
       text-align: center;
       flex: 1;
       .printNumber_boxTop {
           display: flex;
           align-items: baseline;
           justify-content: center;
           .printNumber_boxTopIcon {
               font-size: 12px;
           }
           h3 {
               font-size: 24px;
               margin: 0 15px 0 10px;
           }
           .printNumber_boxTopText {
               font-size: 13px;
               color: #108EE9;
               cursor: pointer;
           }
       }
       .printNumber_boxBot {
           display: flex;
           align-items: center;
           margin-top: 20px;
           justify-content: center;
           span {
               font-size: 13px;
               color: #333;
           }
           p {
               background: #fff;
               border-radius: 15px;
               padding: 2px 10px;
               font-size: 12px;
               color: #108EE9;
               cursor: pointer;
               margin-left: 15px;
           }
       }
    }
    .printNumber_box2 {
        display: flex;
        justify-content: space-between;
        margin: 0 30px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/balance/platformAdvances.vue